import React, { useEffect, useState } from "react"
import gql from "graphql-tag"
import { useQuery } from "@apollo/react-hooks"
import { ResultsLayout } from "../ResultsLayout"
import Loading from "./Loading"

const GET_RESULTS = gql`
  query($hashid: String!) {
    getResults(hashid: $hashid) {
      priorityRows
      hideRows
      showOptions
      restrictOptions
      highlightOptions
      hideOptions
    }
  }
`

const PersonalisedResultsLayout = ({ fineData, hashid }) => {
  const [loading, setLoading] = useState(true)

  const [results, setResults] = useState(fineData);

  let filteredData;

  const { data } = useQuery(GET_RESULTS, {
    variables: { hashid: hashid },
  })

  useEffect(() => {
    const timer = setTimeout(() => {
      if (data) {
        setResults(personaliseData(fineData, data.getResults))

      }
      setLoading(false)
    }, 1200)
    return () => clearTimeout(timer)
  }, [data])


  return (
    <>
      {loading && <Loading />}
      {!loading && <ResultsLayout fineData={results} />}
    </>
  )
}

const personaliseData = (fineRows, resultData) => {
  let priorityRows = []

  if (resultData.priorityRows.length) {
    priorityRows = resultData.priorityRows[resultData.priorityRows.length - 1]
  }

  // Show and highlight options
  const aFilteredRows = fineRows.filter((row, index) => {
    row.order = 100 // default is really high number so it goes at the end
    // Hide rows
    if(resultData.hideRows.includes(row.databaseId)) {
      return false;
    }

    if (priorityRows.includes(row.databaseId)) {
      row.order = priorityRows.indexOf(row.databaseId) + 1
    }

    const filteredOptions = row.rowDetails.fineOptions.filter(function(option) {
      if (resultData.highlightOptions.includes(option.databaseId)) {
        option.highlight = true
      }

      if(resultData.hideOptions.includes(option.databaseId)) {
        return false
      }

      return (
        option.settings.default ||
        resultData.showOptions.includes(option.databaseId)
      )
    })

    fineRows[index].rowDetails.fineOptions = filteredOptions

    return true;
  })
  

  // Order the rows by order number (lowest to highest)
  aFilteredRows.sort((a, b) => {
    if(a.order > b.order) {
      return 1
    } else {
      return -1
    }
  })

  console.log(aFilteredRows)

  return aFilteredRows
}

export default PersonalisedResultsLayout
